import styled from "@emotion/styled";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import { colors } from "../../../theme/colors";
import { Box, Grid } from "@mui/material";

const WhatsappIcon = styled(WhatsAppIcon)`
  color: #67c15e;
`;

const EmailAddIcon = styled(EmailIcon)`
  color: #983bf5;
`;

const ResponsiveImageContainer = styled(Grid)`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

const UnderlineText = styled("span")`
  text-decoration: underline;
  text-decoration-color: ${colors.secondary.main};
`;

const ThickUnderlineText = styled(UnderlineText)`
  text-decoration-thickness: 8px;
  text-underline-offset: -4px;
`;

const ThinUnderlineText = styled(UnderlineText)`
  text-decoration-thickness: 5px;
  text-underline-offset: -2px;
`;

const IconButtonWrapperBlob = styled(Box)`
  background: ${({ color }) => colors[color || "primary"].main};
  border-radius: 54% 46% 31% 69% / 50% 45% 55% 50%;
  padding: 6px;
`;

export {
  WhatsappIcon as WhatsAppIcon,
  ResponsiveImageContainer,
  ThickUnderlineText,
  ThinUnderlineText,
  IconButtonWrapperBlob,
  EmailAddIcon as EmailIcon,
};
